import { createTypes, asyncType, createNS } from '@/utils/actionCreator';

export const NS = createNS('SERVICES');

export default createTypes([...asyncType('GET_SERVICES'), 'RESET'], `${NS}`);
